/**
 * @Author:
 * @Description:
 * @DateTime: Created in 16:31 2019-07-06
 */
import Keep from "../layout/keep";
import Layout from '../layout/layout';

let SystemMessage = [
    {
        path: '/:type/systemMessage',
        name: 'systemMessage',
        component: Layout,
        children: [
            {
                path: 'systemParameter',
                name: 'systemParameter',
                meta: { title: '系统参数' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'system-message-system-parameter',
                        meta: { title: '系统参数' },
                        component: () => import('src/pages/systemMessage/systemParameter/index'),
                    },
                ],
            },
            {
                path: 'sysLog',
                name: 'sysLog',
                meta: { title: '系统日志' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'system-message-sys-log',
                        meta: { title: '系统日志' },
                        component: () => import('src/pages/systemMessage/sysLog/index'),
                    },
                ],
            },
            {
                path: 'systemControl',
                name: 'systemControl',
                meta: { title: '系统反控' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'system-message-system-control',
                        meta: { title: '系统反控' },
                        component: () => import('src/pages/systemMessage/systemControl/index'),
                    },
                ],
            },
            {
                path: 'systemSet',
                name: 'systemSet',
                meta: { title: '系统设置' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'system-set',
                        meta: { title: '系统设置' },
                        component: () => import('src/pages/systemMessage/systemSet/systemSet'),
                    },
                ],
            },
            {
                path: 'dataView',
                name: 'dataView',
                meta: { title: '数据查看' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'system-set',
                        meta: { title: '数据查看' },
                        component: () => import('src/pages/systemMessage/dataView/index'),
                    },
                ],
            },
            {
                path: 'alarmQuery',
                name: 'alarmQuery',
                meta: { title: '报警查询' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'alarm-query',
                        meta: { title: '报警查询' },
                        component: () => import('src/pages/systemMessage/alarmQuery/alarmQuery'),
                    },
                ],
            },
            {
                path: 'devLog',
                name: 'devLog',
                meta: { title: '留样器日志' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'system-message-dev-log',
                        meta: { title: '留样器日志' },
                        component: () => import('src/pages/systemMessage/devLog/index'),
                    },
                ],
            },
            {
                path: 'cameraAlarm',
                name: 'cameraAlarm',
                meta: { title: '摄像头报警' },
                component: Keep,
                children: [
                    {
                        path: 'index',
                        name: 'camera-alarm',
                        meta: { title: '摄像头报警' },
                        component: () => import('src/pages/systemMessage/cameraAlarm/cameraAlarm'),
                    },
                ],
            },
        ],
    }
]

export default SystemMessage
